import Vue from 'vue'
import {
  mdiLockOutline,
  mdiLock,
  mdiAccount,
  mdiViewDashboard,
  mdiDomain,
  mdiCurrencyJpy,
  mdiTablet,
  mdiNote,
  mdiEarth,
  mdiStore,
  mdiBell,
  mdiLink,
  mdiFileDocument,
  mdiRefresh,
  mdiViewList,
  mdiArrowLeft,
  mdiPhone,
  mdiEmail,
  mdiPencil,
  mdiCheck,
  mdiClose,
  mdiFolderOpen,
  mdiClock,
  mdiCheckCircle,
  mdiAlertCircle,
  mdiPlus,
  mdiSettings,
  mdiInformationOutline,
} from '@mdi/js';

// conversion: '<,'>s/mdi\(\w\)\(\w\+\),/\L\1\e\2: mdi\1\2,/g
export const icons = {
  lockOutline: mdiLockOutline,
  lock: mdiLock,
  account: mdiAccount,
  viewDashboard: mdiViewDashboard,
  domain: mdiDomain,
  currencyJpy: mdiCurrencyJpy,
  tablet: mdiTablet,
  note: mdiNote,
  earth: mdiEarth,
  store: mdiStore,
  bell: mdiBell,
  link: mdiLink,
  fileDocument: mdiFileDocument,
  refresh: mdiRefresh,
  viewList: mdiViewList,
  arrowLeft: mdiArrowLeft,
  phone: mdiPhone,
  email: mdiEmail,
  pencil: mdiPencil,
  check: mdiCheck,
  close: mdiClose,
  folderOpen: mdiFolderOpen,
  clock: mdiClock,
  checkCircle: mdiCheckCircle,
  alertCircle: mdiAlertCircle,
  plus: mdiPlus,
  settings: mdiSettings,
  informationOutline: mdiInformationOutline,
}

// conversion: '<,'>s/:.[^,]*/: string/g
declare module 'vue/types/vue' {
  interface Vue {
    mdi: {
      lockOutline: string,
      lock: string,
      account: string,
      viewDashboard: string,
      domain: string,
      currencyJpy: string,
      tablet: string,
      note: string,
      earth: string,
      store: string,
      bell: string,
      link: string,
      fileDocument: string,
      refresh: string,
      viewList: string,
      arrowLeft: string,
      phone: string,
      email: string,
      pencil: string,
      check: string,
      close: string,
      folderOpen: string,
      clock: string,
      checkCircle: string,
      alertCircle: string,
      plus: string,
      settings: string,
      informationOutline: string,
    };
  }
}

Vue.mixin({
  computed: {
    mdi: () => icons,
  }
});